import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";

export interface ModalProps {
  children: React.ReactElement;
  size: "xs" | "sm" | "md" | "lg" | "xl";
  handleClose: (success: boolean) => void;
  show: boolean;
  title: string;
  actions: React.ReactElement;
  classBgColor?: "bg-navy" | "bg-coral" | string;
  classTextColor?: "text-white" | string;
  type?: "info" | "form";
}

export function CustomModal({
  classBgColor = "bg-navy",
  classTextColor = "text-white",
  ...props
}: ModalProps) {
  return (
    <div className="custom-modal">
      <Dialog
        fullWidth={true}
        maxWidth={props.size}
        open={props.show}
        disableEscapeKeyDown={true}
        scroll="body"
      >
        <DialogTitle>{props.title}</DialogTitle>
        <DialogContent dividers={false}>{props.children}</DialogContent>
        <DialogActions>
          {props.actions}
          {/* <Button onClick={() => props.handleClose(false)}>Cancel</Button>
        <Button type="submit">Subscribe</Button> */}
        </DialogActions>
      </Dialog>
    </div>
    // <Modal
    //   backdrop='static'
    //   show={props.show}
    //   onHide={() => props.handleClose(false)}
    //   size={props.size && props.size}
    // >
    //   <ModalHeader
    //     classBgColor={classBgColor}
    //     classTextColor={classTextColor}
    //     text={props.title}
    //     handleClose={() => props.handleClose(false)}
    //   />
    //   <ModalBody>{props.children}</ModalBody>
    //   <ModalFooter>{props.actions}</ModalFooter>
    // </Modal>
  );
}

export default CustomModal;
